import request from 'services/request';
const AGREEMENTS_API = '/Agreements/Api/v1/';
const AGREEMENTS_INDICATOR = `${AGREEMENTS_API}SellOut/Indicators/`;

export async function getIndicator(indicatorName, params, cancelToken) {
  return request(`${AGREEMENTS_INDICATOR}${indicatorName}`, {
    method: 'GET',
    params,
    cancelToken,
  });
}
